<template>
  <div v-title :data-title="$route.name">
    <!-- PC端 -->
    <div
      v-if="offsetwidth > 850"
      style="
        width: 100%;
        overflow: hidden;
        position: relative;
        min-width: 1349px;
        margin-top: 65px;
        background-color: white !important;
      "
    >
      <div style="position: relative">
        <img
          style="width: 100%; height: 100%; object-fit: cover"
          src="../assets/Battertimg/PC/productBanner.jpg"
          alt=""
        />
        <div
          style="
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            color: white !important;
            text-align: center;
            z-index: 10;
            width: 100%;
          "
        >
          <div
            style="
              font-size: 48px;
              font-family: Cotyledon-Regular-bold;
              line-height: 1;
              margin-bottom: 8px;
              width: 100%;
              text-align: center;
            "
          >
            Products
          </div>
        </div>
      </div>

      <!-- 分类导航栏（快速定位） -->
      <div class="category-nav">
        <div
          v-for="category in categories"
          :key="category.ProductTypeId"
          class="category-nav-item"
          :class="{ active: activeCategory === category.ProductTypeId }"
          @click="scrollToCategory(category.ProductTypeId)"
        >
          {{ category.ProductTypeName }}
        </div>
      </div>

      <!-- 产品内容区域（上下结构） -->
      <div
        v-for="category in categories"
        :key="category.ProductTypeId"
        :id="`section-${category.ProductTypeId}`"
        class="product-section"
      >
        <div class="section-title">
          <div class="section-title-text">{{ category.ProductTypeName }}</div>
          <div class="section-title-line"></div>
        </div>

        <!-- 产品网格 -->
        <div class="products-grid-new">
          <div
            v-for="(product, index) in category.productsList"
            :key="index"
            class="product-item"
            @mouseenter="hoverProduct = product.ProductId"
            @mouseleave="hoverProduct = null"
            :class="{
              'active-product':
                activeProduct === product.ProductId ||
                hoverProduct === product.ProductId,
            }"
            @click="selectProduct(product.ProductId)"
          >
            <div class="flex flex_around">
              <div style="object-fit: fill">
                <img :src="product.FilePath" :alt="product.name" />
              </div>
            </div>
            <div class="product-info">
              <div
                class="product-name"
                style="font-family: Cotyledon-Regular-bold"
              >
                {{ product.ProductName }}
              </div>
              <div class="product-name_KeyPra" style="text-align: center">
                {{ product.KeyPrarameters }}
              </div>
              <div class="product-line"></div>
            </div>
          </div>
        </div>
      </div>

      <!-- 底部导航 -->
      <footer class="header-navbar">
        <div class="top-nav" style="height: 28px !important">
          <div class="logo-container">
            <div class="logo">
              <img
                style="height: 28px !important"
                src="../assets/Battertimg/PC/Batteryplantlogo.png"
                alt=""
              />
            </div>
          </div>

          <div class="nav-items">
            <div class="nav-item" @click="goto('HOME')">HOME</div>
            <div class="nav-item" @click="goto('PROJECT')">ABOUT US</div>
            <div class="nav-item" @click="goto('PRODUCTS')">PRODUCTS</div>
            <div class="nav-item" @click="goto('CASE')">GALLERY</div>
            <div class="nav-item" @click="goto('CONTACTUS')">CONTACT US</div>
            <div class="nav-item" @click="goto('CONTACTUS')">BOOK NOW</div>
          </div>
        </div>
        <div
          style="
            height: 1px;
            background-color: #cccccc;
            margin-top: 15px;
            margin-bottom: 18px;
          "
        ></div>
        <div>
          <div class="email-content">(04) 5245 7579</div>
          <div class="email-content">info@batteryplant.com.au</div>
          <div class="email-content">
            203 Blackburn Rd Mount Waverley VIC 3149
          </div>
        </div>
      </footer>
    </div>

    <!-- 移动端 -->
    <div
      v-else
      style="
        width: 100%;
        overflow: hidden;
        background-color: #fff;
        position: relative;
      "
    >
      <div
        style="
          position: relative;
          display: flex;
          justify-content: center;
          align-items: center;
          text-align: center;
          overflow: hidden;
          font-size: 24px;
          padding: 12px 0;
          color: #fff;
          font-weight: bold;
        "
      >
        <img
          style="height: 48px"
          src="../assets/Battertimg/H5/ProductBanner.jpg"
          alt=""
        />
        <div class="pos_abs">Products</div>
      </div>

      <!-- 移动端分类导航 -->
      <div class="mobile-category-nav">
        <div
          v-for="category in categories"
          :key="category.ProductTypeId"
          class="mobile-category-item"
          @click="scrollToCategory(category.ProductTypeId)"
        >
          {{ category.ProductTypeName }}
        </div>
      </div>

      <!-- 移动端产品内容 -->
      <div
        v-for="category in categories"
        :key="category.ProductTypeId"
        class="mobile-product-section"
      >
        <div class="mobile-section-title">
          {{ category.ProductTypeName }}
        </div>

        <el-row :gutter="16">
          <el-col
            :span="24"
            v-for="(product, index) in category.productsList"
            :key="index"
          >
            <div
              class="mobile-product-card"
              @click="selectProduct(product.ProductId)"
            >
              <div class="flex flex_around">
                <img
                  :src="product.FilePath"
                  :alt="product.ProductName"
                  class="mobile-product-img"
                />
              </div>
              <div class="mobile-product-info">
                <div class="mobile-product-name">
                  {{ product.ProductName }}
                </div>
                <div class="mobile-product-params">
                  {{ product.KeyPrarameters }}
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>

      <!-- 移动端底部导航 -->
<!-- 移动端底部导航 -->
<footer class="mobile-footer-navbar">
  <div class="vertical-container">
    <!-- LOGO区域 -->
    <div class="logo-section">
      <div class="logo-container">
        <div class="logo">
          <img
            style="height: 32px"
            src="../assets/Battertimg/PC/Batteryplantlogo.png"
            alt="Battery Plant Logo"
          />
        </div>
      </div>
    </div>

    <!-- 导航项区域 -->
    <div class="nav-section">
      <div
        class="nav-item"
        :class="{ active: activeNav === 0 }"
        @click="
          activateNav(0);
          goto('HOME');
        "
      >
        HOME
      </div>
      <div
        class="nav-item"
        :class="{ active: activeNav === 1 }"
        @click="
          activateNav(1);
          goto('PROJECT');
        "
      >
        ABOUT US
      </div>
      <div
        class="nav-item"
        :class="{ active: activeNav === 2 }"
        @click="
          activateNav(2);
          goto('PRODUCTS');
        "
      >
        PRODUCTS
      </div>
      <div
        class="nav-item"
        :class="{ active: activeNav === 3 }"
        @click="
          activateNav(3);
          goto('CASE');
        "
      >
        GALLERY
      </div>
      <div
        class="nav-item"
        :class="{ active: activeNav === 4 }"
        @click="
          activateNav(4);
          goto('CONTACTUS');
        "
      >
        CONTACT US
      </div>
      <div
        class="nav-item"
        :class="{ active: activeNav === 5 }"
        @click="
          activateNav(5);
          goto('CONTACTUS');
        "
      >
        BOOK NOW
      </div>
    </div>

    <!-- 分隔线 -->
    <div class="divider-line"></div>

    <!-- 联系方式区域 -->
    <div class="contact-section">
      <div class="email-contentmobile">(04) 5245 7579</div>
      <div class="email-contentmobile">info@batteryplant.com.au</div>
      <div class="email-contentmobile">
        203 Blackburn Rd Mount Waverley VIC 3149
      </div>
    </div>
  </div>
</footer>
    </div>
  </div>
</template>

<script>
import { get } from "../assets/api/api";
import {
  ProductSummarizeList,
  WebsiteProductType,
} from "../assets/api/request";

export default {
  data() {
    return {
      offsetwidth: typeof window !== 'undefined' ? window.innerWidth : 1920,
      activeNav: null,
      categories: [],
      activeCategory: null,
      hoverProduct: null,
      activeProduct: null,
    };
  },

  created() {
    console.log('组件 created, offsetwidth:', this.offsetwidth);
    this.getCategory();
  },

  mounted() {
    console.log('组件 mounted');
    document.documentElement.scrollTop = 0;
    window.addEventListener('resize', this.handleResize);
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },

  methods: {
    handleResize() {
      this.offsetwidth = window.innerWidth;
    },

    getCategory() {
      console.log('开始获取分类...');
      get(WebsiteProductType).then((res) => {
        console.log('分类接口返回:', res);
        this.categories = res.data.data;
        if (this.categories.length > 0) {
          this.activeCategory = this.categories[0].ProductTypeId;
          this.categories.forEach((item, index) => {
            this.getProductList(item.ProductTypeId, index);
          });
        }
      }).catch(err => {
        console.error('获取分类失败:', err);
      });
    },

    getProductList(id, index) {
      console.log('获取产品列表, 分类ID:', id);
      get(
        ProductSummarizeList +
          "?ToProductTypeId=" +
          id +
          "&PageSize=0" +
          "&PageIndex=0"
      ).then((res) => {
        console.log('产品列表返回:', res);
        this.$set(this.categories[index], "productsList", res.data.data);
      }).catch(err => {
        console.error('获取产品列表失败:', err);
      });
    },

    scrollToCategory(categoryId) {
      this.activeCategory = categoryId;
      const element = document.getElementById(`section-${categoryId}`);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    },

    selectProduct(productId) {
      this.activeProduct = productId;
      this.$store.commit("SetProductId", productId);
      this.$router.push("/Productinformation");
    },

    activateNav(index) {
      this.activeNav = index;
    },

    goto(name) {
      if (name == "HOME") {
        window.sessionStorage.setItem("activeIndexh5", "/index");
        this.$router.push("/index");
      } else if (name == "PROJECT") {
        window.sessionStorage.setItem("activeIndexh5", "/Project");
        this.$router.push("/Project");
      } else if (name == "PRODUCTS") {
        window.sessionStorage.setItem("activeIndexh5", "/Productslist");
        document.documentElement.scrollTop = 0;
      } else if (name == "CASE") {
        window.sessionStorage.setItem("activeIndexh5", "/Case");
        this.$router.push("/Case");
      } else if (name == "CONTACTUS") {
        window.sessionStorage.setItem("activeIndexh5", "/ContactUs");
        this.$router.push("/ContactUs");
      }
    },
  },
};
</script>

<style scoped>
/* 分类导航栏 */
.category-nav {
  display: flex;
  justify-content: center;
  gap: 40px;
  padding: 30px 0 20px;
  background-color: white;
  flex-wrap: wrap;
  border-bottom: 1px solid #eee;
}

.category-nav-item {
  font-size: 18px;
  font-family: Cotyledon-Regular;
  padding: 8px 20px;
  cursor: pointer;
  transition: all 0.3s;
  color: #666;
  border-radius: 30px;
}

.category-nav-item:hover {
  color: #1890ff;
}

.category-nav-item.active {
  color: #1890ff;
  background-color: #e6f7ff;
}

/* 产品区域 */
.product-section {
  padding: 40px 140px;
  border-bottom: 1px solid #f0f0f0;
}

/* 标题左对齐 */
.section-title {
  text-align: left;
  margin-bottom: 40px;
  padding-left: 20px;
}

.section-title-text {
  font-size: 32px;
  font-family: Cotyledon-Regular-bold;
  color: #333;
  margin-bottom: 10px;
}

/* 装饰线左对齐 */
.section-title-line {
  width: 60px;
  height: 3px;
  background: linear-gradient(to right, #007bff, #28a745);
  margin: 0;
}

/* 产品网格布局 */
.products-grid-new {
  flex: 1;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  margin-bottom: 20px;
}

/* 产品卡片样式 */
.product-item {
  cursor: pointer;
  transition: all 0.3s;
  text-align: center;
}

.product-item img {
  height: 240px;
  margin-bottom: 20px;
  transition: all 0.3s ease;
}

.product-info {
  text-align: center;
}

.product-name {
  font-size: 20px;
  color: #333;
  margin-bottom: 8px;
}

.product-name_KeyPra {
  font-size: 14px;
  color: #666;
  padding: 0 10px;
}

.product-line {
  width: 50px;
  height: 2px;
  background-color: #eee;
  margin: 12px auto 0;
  transition: all 0.3s;
}

/* 悬停效果 */
.product-item:hover {
  transform: translateY(-5px);
}

.product-item:hover .product-line {
  background-color: #1890ff;
  width: 80px;
}

.product-item:hover img {
  scale: 1.05;
}

.product-item:hover .product-name {
  color: #1890ff;
}

/* 移动端样式 */
.mobile-category-nav {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
  padding: 15px;
  background-color: white;
  border-bottom: 1px solid #eee;
}

.mobile-category-item {
  font-size: 14px;
  padding: 6px 16px;
  background-color: #f5f5f5;
  border-radius: 20px;
  cursor: pointer;
}

.mobile-category-item:active {
  background-color: #1890ff;
  color: white;
}

.mobile-product-section {
  padding: 20px 15px;
  border-bottom: 8px solid #f5f5f5;
}

.mobile-section-title {
  font-size: 20px;
  font-family: Cotyledon-Regular-bold;
  text-align: center;
  padding: 15px 0;
  color: #333;
  position: relative;
}

.mobile-section-title::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 40px;
  height: 3px;
  background: linear-gradient(to right, #007bff, #28a745);
}

.mobile-product-card {
  display: flex;
  align-items: center;
  gap: 15px;
  background-color: #f9f9f9;
  border-radius: 12px;
  padding: 15px;
  margin-bottom: 15px;
  cursor: pointer;
  transition: all 0.3s;
}

.mobile-product-card:active {
  background-color: #e6f7ff;
  transform: scale(0.98);
}

.mobile-product-img {
  width: 80px;
  height: 80px;
  object-fit: contain;
}

.mobile-product-info {
  flex: 1;
}

.mobile-product-name {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  margin-bottom: 6px;
}

.mobile-product-params {
  font-size: 12px;
  color: #999;
}

/* 响应式 */
@media (max-width: 1400px) {
  .product-section {
    padding: 40px 80px;
  }
}

@media (max-width: 1200px) {
  .product-section {
    padding: 30px 40px;
  }
  
  .products-grid-new {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }
  
  .product-item img {
    height: 180px;
  }
  
  .section-title-text {
    font-size: 28px;
  }
}

@media (max-width: 768px) {
  .product-section {
    padding: 20px 15px;
  }
  
  .products-grid-new {
    grid-template-columns: repeat(2, 1fr);
    gap: 15px;
  }
  
  .product-item img {
    height: 120px;
  }
  
  .product-name {
    font-size: 14px;
  }
  
  .product-name_KeyPra {
    font-size: 10px;
  }
  
  .section-title-text {
    font-size: 20px;
  }
  
  .category-nav {
    display: none;
  }

  /* 移动端标题居中 */
  .section-title {
    text-align: center;
    padding-left: 0;
  }
  
  .section-title-line {
    margin: 0 auto;
  }
}

@media (min-width: 769px) {
  .mobile-category-nav {
    display: none;
  }
}
</style>

<style scoped>
/* 保留原有的其他样式 */
.header-navbar {
  padding: 20px 40px;
  background-color: white;
}

.top-nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo-container {
  flex-shrink: 0;
}

.logo {
  display: flex;
  align-items: center;
  gap: 8px;
}

.nav-items {
  display: flex;
  gap: 30px;
}

.nav-item {
  font-size: 14px;
  font-weight: bold;
  color: #333;
  cursor: pointer;
  transition: all 0.3s;
  padding: 5px 0;
  position: relative;
  border-bottom: 2px solid transparent;
}

.nav-item:hover,
.nav-item.active {
  color: #0c80da !important;
}

.email-content {
  font-size: 12px;
  color: #666;
  text-align: right;
  line-height: 1.6;
}

/* 移动端底部导航 */
.mobile-footer-navbar {
  background-color: white;
  padding: 20px;
}

.vertical-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.nav-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.contact-section {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.email-contentmobile {
  font-size: 12px;
  color: #666;
  line-height: 1.6;
}

@media (max-width: 768px) {
  .top-nav {
    flex-direction: column;
    gap: 20px;
  }

  .nav-items {
    flex-wrap: wrap;
    justify-content: center;
    gap: 15px;
  }

  .email-content {
    text-align: center;
  }
}
</style>